import { useMemo } from 'react';
import { useActiveControl } from '../useActiveControl';
export const useModal = ({ isRequired, initialActive, heading, size, backButton, returnFocusOnDeactivate = false }) => {
    const modalControl = useActiveControl({ initialActive });
    const { isActive, open, close } = modalControl;
    /**
     * Initiator Props
     */
    const initiatorProps = {
        onClick: open
    };
    /**
     * Modal Props
     */
    const modalProps = useMemo(() => ({
        isActive,
        onBlModalClose: close,
        dismissible: !isRequired,
        disableBackdropClick: isRequired,
        disableEscClick: isRequired,
        heading,
        size,
        backButton,
        returnFocusOnDeactivate
    }), [
        backButton,
        close,
        heading,
        isActive,
        isRequired,
        returnFocusOnDeactivate,
        size
    ]);
    return {
        modalControl,
        modalProps,
        initiatorProps
    };
};
